import { cpf } from 'cpf-cnpj-validator';

class CPFValidatorAdapter {
  isValid (cpfNumber) {
    return cpf.isValid(cpfNumber);
  }
}

export default CPFValidatorAdapter;
